export function makeDraggable (el, { onClick } = {}) {
  let move = false
  let startX = 0 // 시작 x 좌표
  let startY = 0 // 시작 y 좌표
  let deltaX = 0 // 이동한 x 방향
  let deltaY = 0 // 이동한 y 방향
  let originLeft = 0 // el의 x(left) 위치
  let originTop = 0 // el의 y(right) 위치
  const DRAG_THRESHOLD = 12

  // 움직인 값만큼 스타일 설정
  const setPosition = (pageX, pageY) => {
    const elWidth = el.offsetWidth
    const elHeight = el.offsetHeight

    let left = pageX - deltaX
    let top = pageY - deltaY

    // 화면 밖으로 나가지 않도록
    const maxLeft = window.innerWidth - elWidth
    const maxTop = window.innerHeight - elHeight

    left = Math.max(0, Math.min(left, maxLeft))
    top = Math.max(0, Math.min(top, maxTop))

    el.style.left = `${left}px`
    el.style.top = `${top}px`
  }

  // 움직인 값 계산
  const moveElement = (event, offsetX, offsetY) => {
    const pageX = event.type.startsWith('touch')
      ? event.touches[0].pageX
      : event.pageX
    const pageY = event.type.startsWith('touch')
      ? event.touches[0].pageY
      : event.pageY

    // 움직인 값이 70보다 작으면 마우스 이동 false -> onMouseUp , onTouchEnd에서 클릭 이벤트로 시작
    const dist = Math.hypot(pageX - startX, pageY - startY)

    if (dist > DRAG_THRESHOLD) {
      move = true
      setPosition(pageX, pageY)
    }
  }

  // PC 마우스 움직일때
  const onMouseMove = e => moveElement(e, originLeft, originTop)

  // 모바일 터치 움직일때
  const onTouchMove = e => moveElement(e, originLeft, originTop)

  // PC 마우스 드랍
  const onMouseUp = () => {
    if (!move && typeof onClick === 'function') onClick()
    cleanup()
  }

  // 모바일 터치 드래그 드랍
  const onTouchEnd = () => {
    if (!move && typeof onClick === 'function') onClick()
    cleanup()
  }

  // 이벤트 리스너 제거
  const cleanup = () => {
    move = false
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', onMouseUp)
    window.removeEventListener('touchmove', onTouchMove)
    window.removeEventListener('touchend', onTouchEnd)
  }

  // PC 마우스 눌렀을때
  const onMouseDown = e => {
    e.preventDefault()
    originLeft = el.offsetLeft
    originTop = el.offsetTop
    startX = e.pageX
    startY = e.pageY
    deltaX = startX - originLeft
    deltaY = startY - originTop

    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
  }

  // 모바일 터치 했을때
  const onTouchStart = e => {
    e.preventDefault()
    originLeft = el.offsetLeft
    originTop = el.offsetTop
    startX = e.touches[0].pageX
    startY = e.touches[0].pageY
    deltaX = startX - originLeft
    deltaY = startY - originTop

    window.addEventListener('touchmove', onTouchMove, { passive: false })
    window.addEventListener('touchend', onTouchEnd)
  }

  el.addEventListener('mousedown', onMouseDown)
  el.addEventListener('touchstart', onTouchStart, { passive: false })
}
